namespace advisorop.components.advisor {

    export class MemoAccountController {

        public model: Array<domains.IMemoAccount>;
        public dg;
        n: number;
        


        static $inject = ["advisorService", "$rootScope"];
        constructor(private advisorService: services.AdvisorService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Memos"
                },
                bindingOptions: {
                    dataSource: "vm.model"
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: "dgAlertLogs"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: 'dateCreate', dataType: 'date', format: 'shortDateShortTime', caption: 'Occured', width: 130 },
                    { dataField: 'nativeMarketValue', caption: 'Market Value' },
                    //{ dataField: 'status', caption: 'Status' },
                    { dataField: 'usdMarketValue', caption: 'USD Value' },
                    { dataField: 'includeInAUM', caption: 'Include in AUM' },
                    { dataField: 'description', caption: 'Description' },
                    { dataField: 'id', caption: '#', cellTemplate: 'colActions' }
                ]
            };

        }

        
       
        
        $onInit() {

            this.advisorService.getMemoAccounts()
                .success((data) => {
                    this.model = data;
                }).error((data, status) => {
                    toastr.error("Memo Accounts list error: " + status + ":" + data);
                });
        }



        $routerOnActivate(next, previous) {
        }


    }

    class MemoAccount implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {

            this.bindings = {
                n: "<"
            };
            this.controller =  MemoAccountController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/memo-account.html';
        }
    }
    angular.module(Constants.APP).component("memoAccount", new MemoAccount());

}